import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useImageGeneration } from '.';

export default function UseCaseSelector() {
  const { useCaseType, setUseCaseType } = useImageGeneration();

  const useCaseOptions = [
    { value: 'usPassport', label: 'US Passport' },
    { value: 'ukPassport', label: 'UK Passport' },
    { value: 'euPassport', label: 'EU Passport' },
    { value: 'usVisa', label: 'US Visa' },
    { value: 'ukVisa', label: 'UK Visa' },
    { value: 'euVisa', label: 'EU Visa' },
    { value: 'idUs', label: 'US ID' },
    { value: 'idEu', label: 'EU ID' },
    { value: 'usDrivingLicense', label: 'US Driving License' },
    { value: 'euDrivingLicense', label: 'EU Driving License' },
    { value: 'gradutionPortrait', label: 'Graduation Portrait' },
    { value: 'realEstateAgent', label: 'Real Estate Agent' },
    { value: 'cvPhoto', label: 'CV Photo' },
    { value: 'linkedInPhoto', label: 'LinkedIn Photo' },
    { value: 'corporateHeadshot', label: 'Corporate Headshot' },
    { value: 'casualHeadshot', label: 'Casual Headshot' },
  ] as const;

  return (
    <div className='px-4 space-y-2'>
      <Label className='text-base font-semibold text-neutral-50 leading-tight'>
        Use Case
      </Label>
      <RadioGroup
        value={useCaseType}
        onValueChange={setUseCaseType}
        className='space-y-2 max-h-60 overflow-y-auto'
      >
        {useCaseOptions.map((option) => (
          <div key={option.value} className='flex items-center space-x-2'>
            <RadioGroupItem
              value={option.value}
              id={option.value}
              className='text-fuchsia-600 border-fuchsia-600 data-[state=checked]:bg-fuchsia-600'
            />
            <Label
              htmlFor={option.value}
              className='text-stone-50/90 text-sm cursor-pointer'
            >
              {option.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
      <Label className='text-xs text-stone-50/60'>
        Select the use case for your image generation.
      </Label>
    </div>
  );
}
